
export default {
  props: {
    content: {
      type: [Object, Array],
      required: true,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
};
